import React from 'react';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { FormMicTypeSample } from './FormMicTypeSample';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalMicTypeSample = (props) => {
    const {
        modal, modalTitle, method, loading,
        name, abbreviation, handleInputChange,
        validaciones, saveCreate, saveUpdate, closeDialog
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-industries-alt-4 f-24 "></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v38 `}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdate}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}>
                        Cancelar
                    </Button>
                </>
            }
        >

            {
                method === "create"
                    ? <FormMicTypeSample
                        button={ModalButtonSave}
                        {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveCreate, }}
                    />
                    :
                    (method === "update")
                        ?
                        <FormMicTypeSample
                            button={ModalButtonUpdate}
                            {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, name, abbreviation }}
                        />
                        :
                        null
            }
        </Dialog>
    )
}